import React, {useReducer, createContext} from 'react';
import {PackageTypes, PackageTypes_Reverse} from "../dataStore/FilterDataStore";
import {PackageStatuses, TimeUnits} from "../dataStore/FilterDataStore";
import { FiltersDataReducer } from "../reducer/FiltersDataReducer";

export const FiltersDataContext = createContext();

const initialFilterData = {

    cycles : [],
    CPT : [],
    packageTypes : Object.keys(PackageTypes),
    packageTypes_Reverse : Object.keys(PackageTypes_Reverse),
    packageStatuses : PackageStatuses,
    dwellTimeUnits : TimeUnits,
    deliveryWindow : [],
    CPTLabel: '',
    filterIdentifier: 'CPT'
}

const FiltersDataContextProvider = (props) => {

    const [filtersData, dispatchData] = useReducer(FiltersDataReducer, initialFilterData);
    return (
        <FiltersDataContext.Provider value = {{filtersData, dispatchData}}>
            {props.children}
        </FiltersDataContext.Provider>
    )
}

export default FiltersDataContextProvider;



// WEBPACK FOOTER //
// ./src/commons/context/FiltersDataContext.js